export default "__VITE_ASSET__ruDWj430__"